/**
 * Client-side Google Places proxy via Cloudflare Pages Functions.
 * Keeps GOOGLE_PLACES_API_KEY off the browser bundle.
 */
import type {
  GooglePlacesAutocompleteResult,
  GooglePlacesDetailsResult,
} from "@/core/services/types/google-places.types";

export class GooglePlacesService {
  async autocomplete(input: string): Promise<GooglePlacesAutocompleteResult> {
    const response = await fetch("/api/google-places/autocomplete", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ input }),
    });

    if (!response.ok) {
      return { success: false, error: "search_failed" };
    }

    return (await response.json()) as GooglePlacesAutocompleteResult;
  }

  async getPlaceDetails(placeId: string): Promise<GooglePlacesDetailsResult> {
    const response = await fetch("/api/google-places/details", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ placeId }),
    });

    if (!response.ok) {
      return { success: false, error: "details_failed" };
    }

    return (await response.json()) as GooglePlacesDetailsResult;
  }
}
